/**
 * /purchase-orders/new — Create a new Purchase Order.
 * Delegates to the <PurchaseOrderForm> component.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useConstructionPack } from "@/lib/useConstructionPack";
import { PurchaseOrderForm } from "@/components/PurchaseOrderForm";

export const Route = createFileRoute("/_auth/purchase-orders/new")({
  component: PurchaseOrderNewPage,
});

function PurchaseOrderNewPage() {
  const { enabled: constructionEnabled } = useConstructionPack();
  if (!constructionEnabled) return null;
  return <PurchaseOrderForm />;
}
